import { IValidationError } from "../typings";

export const AUTH_TOKEN_EXPIRED = "AUTH_TOKEN_EXPIRED";

export class ExpError extends Error {
  statusCode: number;
  message: string;
  validationErrors?: IValidationError[];
  data?: object;
  code?: string;

  constructor(
    statusCode = 500,
    message: string,
    validationErrors?: IValidationError[] | undefined,
    data?: object,
    code?: string,
  ) {
    super();
    this.name = "ExpError";
    this.message = message;
    this.statusCode = statusCode;
    this.validationErrors = validationErrors;
    this.data = data;
    this.code = code;
  }
}
